import React from 'react';
import SectionTitle from '../../components/SectionTitles/SectionTitle';
import ContactFrom from '../../components/ContactFrom/ContactFrom.jsx';
import ProjectForm from '../../components/ProjectForm/ProjectForm.jsx';

const ContactFromContainer = () => {
    return (
        <div className="contact-form-section section section-padding-t90-b100 bg-primary-blue">
            <div className="container">
                <div className="row">
                    <div className="offset-lg-2 col-lg-8">
                        <SectionTitle
                            headingOption="fz-32"
                            title="Start your Free 30 Days Trial"
                            subTitle="MyFSconnect is now the Instant Communication solution of choice for Law Enforcement, Life Safety, Transportation and Hospitality sectors. Contact the MyFSconnect team to get started on a free trial and see what MyFSconnect can do for you."
                        />
                        <ProjectForm/>
                        {/* <ContactFrom /> */}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactFromContainer
